import { render, staticRenderFns } from "./thereAreTeams.vue?vue&type=template&id=23fff03c"
import script from "./thereAreTeams.vue?vue&type=script&lang=js"
export * from "./thereAreTeams.vue?vue&type=script&lang=js"
import style0 from "./thereAreTeams.vue?vue&type=style&index=0&id=23fff03c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports